import services from "@/services";
import { useAssessmentStore } from "@/stores/assessment";
import {
  AddCircleOutlineOutlined,
  AutoModeOutlined,
} from "@mui/icons-material";
import { Alert, Button } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useEffectOnce } from "react-use";
import { DataTable, ErrorPage, FullScreenLoading } from "../../../components";
import { useAuth, useHeaderAdmin } from "../../../hooks";
import ModalActivate from "./modal-activate-deactivate";
import ModalRegister from "./modal-register";
import ModalUpdate from "./modal-update";
import { TABLE_COLUMNS } from "./table-columns";
import { TableToolbar } from "./table-toolbar";
import { useData } from "./use-data";

export default function Assessment() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { setAction } = useHeaderAdmin();
  const [edit, setEdit] = useState(false);
  const [activate, setActivate] = useState(false);
  const { isLoading, error, assessments, lessons, modules } = useData();
  const { selectedItem, setSelectedItem, clearSelectedItem } =
    useAssessmentStore();
  const [isModalRegisterOpen, setIsModalRegisterOpen] =
    useState<boolean>(false);

  const toggleModalRegister = () =>
    setIsModalRegisterOpen(!isModalRegisterOpen);

  const closeModalUpdate = () => {
    clearSelectedItem();
    setActivate(false);
    setEdit(false);
  };

  useEffectOnce(() => {
    setAction(
      <Button onClick={toggleModalRegister}>
        <AddCircleOutlineOutlined />
        <span>Registar</span>
      </Button>
    );
  });

  if (isLoading) return <FullScreenLoading />;

  if (error) return <Alert severity="error">{(error as Error).message}</Alert>;

  if (!assessments) return <ErrorPage text="No assessments found" />;

  return (
    <div className="gap-6 px-2 flex flex-wrap">
      <ModalRegister open={isModalRegisterOpen} onClose={toggleModalRegister} />
      <ModalActivate
        open={selectedItem !== null && activate}
        onClose={closeModalUpdate}
      />
      <ModalUpdate
        open={selectedItem !== null && edit}
        onClose={closeModalUpdate}
      />

      <DataTable
        columns={TABLE_COLUMNS}
        data={assessments}
        inputProps={{ name: "name" }}
        toolbar={(table) => (
          <TableToolbar table={table} lessons={lessons} modules={modules} />
        )}
        actions={{
          queryKey: ["/exams"],
          async onDelete(data) {
            await services.assessment.deleteById(data.id);
          },
          async onUpdate(data) {
            setSelectedItem(data);
            setEdit(true);
          },
          async onSetSpecialAction(data) {
            setSelectedItem(data);
            setActivate(true);
          },
          async onOpen(data) {
            if (user && user.type === "ADMIN") {
              const uri = `/${user.type.toLowerCase()}/assessments/new/${data.id}`;
              navigate(uri);
            }
          },
          specialActionIcon: <AutoModeOutlined />,
        }}
      />

      {/* <Exams /> */}
    </div>
  );
}
